import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X, MessageSquare } from "lucide-react";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleWhatsApp = () => {
    window.open("https://wa.me/6588921053?text=Hi, I'd like to book a valet service", "_blank");
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname !== "/") {
      window.location.href = `/#${sectionId}`;
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-white/95 backdrop-blur-md shadow-lg"
          : "bg-white/80 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="/logo.jpg" 
              alt="Valet Find Me" 
              className="h-16 w-16 rounded-full object-cover transform group-hover:scale-110 transition-transform shadow-lg"
            />
            <div>
              <h1 className="text-2xl font-bold text-slate-900">Valet Find Me</h1>
              <p className="text-xs text-slate-600">Drink don't drive, be home safe</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-slate-700 hover:text-yellow-600 font-medium">
              Home
            </Link>
            <button
              onClick={() => scrollToSection("services")}
              className="text-slate-700 hover:text-yellow-600 font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("pricing")}
              className="text-slate-700 hover:text-yellow-600 font-medium"
            >
              Pricing
            </button>
            <Link to="/careers" className="text-slate-700 hover:text-yellow-600 font-medium">
              Careers
            </Link>
            <button
              onClick={() => scrollToSection("contact")}
              className="text-slate-700 hover:text-yellow-600 font-medium"
            >
              Contact
            </button>
            <Button
              onClick={handleWhatsApp}
              className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold shadow-lg"
            >
              <MessageSquare className="w-4 h-4 mr-2" />
              Book Now
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-slate-700"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-6 pb-4 space-y-4">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-slate-700 hover:text-yellow-600 font-medium"
            >
              Home
            </Link>
            <button
              onClick={() => scrollToSection("services")}
              className="block w-full text-left text-slate-700 hover:text-yellow-600 font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("pricing")}
              className="block w-full text-left text-slate-700 hover:text-yellow-600 font-medium"
            >
              Pricing
            </button>
            <Link
              to="/careers"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-slate-700 hover:text-yellow-600 font-medium"
            >
              Careers
            </Link>
            <button
              onClick={() => scrollToSection("contact")}
              className="block w-full text-left text-slate-700 hover:text-yellow-600 font-medium"
            >
              Contact
            </button>
            <Button
              onClick={handleWhatsApp}
              className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-semibold"
            >
              <MessageSquare className="w-4 h-4 mr-2" />
              Book Now
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
